import { render, staticRenderFns } from "./component-upload.vue?vue&type=template&id=168ab7ba&"
import script from "./component-upload.vue?vue&type=script&lang=js&"
export * from "./component-upload.vue?vue&type=script&lang=js&"
import style0 from "./component-upload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports